// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index {
    width: 3%;
}

.rank-abbr-name {
    width: 5%;
}

.full-name {
    width: 15%;
}

.org-abbr-name {
    width: 8%;
}

.unit-name {
    width: 10%;
}

.spc-name {
    width: 10%;
}

.age {
    width: 5%;
}

.tot-seq {
    width: 5%;
}

.senior-of-rank {
    width: 5%;
}

.ecl-score {
    width: 5%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Spc/Spc.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb","sourcesContent":[".index {\n    width: 3%;\n}\n\n.rank-abbr-name {\n    width: 5%;\n}\n\n.full-name {\n    width: 15%;\n}\n\n.org-abbr-name {\n    width: 8%;\n}\n\n.unit-name {\n    width: 10%;\n}\n\n.spc-name {\n    width: 10%;\n}\n\n.age {\n    width: 5%;\n}\n\n.tot-seq {\n    width: 5%;\n}\n\n.senior-of-rank {\n    width: 5%;\n}\n\n.ecl-score {\n    width: 5%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
